import { combineReducers } from 'redux';
import data from './data';
import auth from './authReducer';
import filter from './filter';
import view from './view';
import hashAuth from './hashAuth';

export default combineReducers({
  data,
  filter,
  auth,
  view,
  hashAuth,
});
